import React from 'react';

import {IqosLogo, IqosLogoCollapsed} from '.';

const IqosExtendedLogo = () => {
    return (
        <div className='flex items-center justify-center gap-3 md:gap-4'>
            <IqosLogoCollapsed className='h-auto w-[47px] lg:w-16' />
            <IqosLogo className='h-auto w-[84px] lg:w-[115px]' />
        </div>
    );
};

export default IqosExtendedLogo;
